import { render, staticRenderFns } from "./NearIncidentReport.vue?vue&type=template&id=38414495&"
import script from "./NearIncidentReport.vue?vue&type=script&lang=js&"
export * from "./NearIncidentReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports